import { Box, Button, Typography } from "@mui/material";
import { ImageService } from "../services/image.service";
import { Images } from "../models/assets-files";
import { theme } from "../mui/theme";
import { useNavigate } from "react-router-dom";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: `calc(100dvh - ${theme.custom.appHeaderHeight} - ${theme.custom.appFooterHeight} - 48px)`,
        gap: "5px",
      }}
    >
      <img
        style={{ width: "186px" }}
        src={ImageService.getLocalImgPath(
          Images.Folders.GENERAL,
          Images.General[404],
          "svg"
        )}
      />
      <Typography variant="h1" sx={{ color: theme.palette.text.primary }}>
        404
      </Typography>

      <Typography
        variant="h6"
        sx={{ color: theme.palette.primary.main, marginBottom: "15px" }}
      >
        Sorry, we couldn׳t find this page
      </Typography>

      <Button
        onClick={() => navigate("/")}
        variant="contained"
        sx={{
          background: theme.palette.text.primary,
          fontSize: "20px",
          borderRadius: "8px",
          width: "400px",
        }}
      >
        Back to homepage
      </Button>
    </Box>
  );
};
